import { useMutation } from '@tanstack/react-query';
import { getConfigService, getTokenService } from '../../../../services/angular-bridge';
import type { CreateCollectionBody } from '../../../../types/collection';

interface ValidateParams {
  projectId: string;
  sourceConfig: Record<string, any>;
  collectionBody: CreateCollectionBody;
}

export function useValidateForensicImage() {
  return useMutation({
    mutationFn: async ({ projectId, sourceConfig, collectionBody }: ValidateParams) => {
      const params = new URLSearchParams();
      Object.entries(sourceConfig).forEach(([k, v]) => {
        if (v !== undefined && v !== null && k !== 'files' && k !== 'getListings') {
          params.set(k, String(v));
        }
      });
      const base = getConfigService().getServerBaseUrl();
      const token = getTokenService().GetAccessToken?.();
      const res = await fetch(`${base}/project/${projectId}/validateForensicImage?${params}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(collectionBody),
      });
      if (!res.ok) throw new Error(`${res.status}`);
    },
  });
}
